// extracted by mini-css-extract-plugin
export default {"select":"MuiSingleSelect-module__select--Qb7yZ","searchIconWrapper":"MuiSingleSelect-module__searchIconWrapper--pRHf5"};